export const API_MODULES = {
  CATEGORY: 'category',
  SUB_CATEGORY: 'subcategory',
  BRAND: 'brand',
  METRIC: 'metric',
  PACK_SIZE: 'pack-size',
  PRODUCT: 'product',
  RECIPE: 'recipe',
  RECIPE_CATEGORY: 'recipe-category',
  COOKING_SKILL: 'cooking-skill',
  CUISINE: 'cuisine',
  MEALTIME: 'mealtime',
  CAREERS_UAE: 'career-uae',
  CAREERS_OMAN: 'career-oman',
  CONTACT:'contact'
};
